import { NgModule } from '@angular/core';
import { CapitalizePipeModule } from '../../../../pipes/format/capitalize.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppWidgetGroupComponent } from './widget-group.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';

@NgModule({
    imports: [
        SharedModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        SharedDirectivesModule,
        MatChipsModule,
        CapitalizePipeModule,
    ],
    declarations: [AppWidgetGroupComponent],
    exports: [AppWidgetGroupComponent],
})
export class AppWidgetGroupModule
{
}
